import {ChangeDetectorRef, Component, EventEmitter, OnInit, Output} from '@angular/core';
import {PreLoginSystemConfigurationValues} from "../../../../common/configuration/services/prelogin.system.configuration.manager";
import {ChangePasswordResult, CreateAccountResult} from "../common/common.types";

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss']
})
export class SummaryComponent implements OnInit {
  @Output() backToLogin = new EventEmitter();
  @Output() backToSearch = new EventEmitter();
  @Output() backToOneTimeCode = new EventEmitter();

  public patient: any;

  public email: string;
  public success: boolean;
  public contactInfo: string;

  public messageActionDone = '';

  public messageActionDetailsText1 = '';
  public messageActionDetailsText2 = '';
  public messageActionDetailsText3 = '';
  public contactPositionIndex = 2;

  public informationText1 = '';
  public informationText2 = '';
  public informationText3 = '';
  public informationActionTextIndex = 0;
  public informationAction: any;

  constructor(private sysConfig: PreLoginSystemConfigurationValues,
              private changeDetector: ChangeDetectorRef) {
    this.sysConfig.GetMainContactTelephoneAsync().subscribe(value => {
      this.contactInfo = value;
      this.changeDetector.markForCheck();
    });
  }

  ngOnInit() {
  }

  public setPatient(patient: any) {
    this.patient = patient;
  }

  public setAccountAlreadyExists() {
    this.success = false;

    this.messageActionDone = 'AccountCreationFailed';
    this.messageActionDetailsText1 = 'PatientAccountAlreadyExists';
    this.messageActionDetailsText2 = 'PleaseContactUs';
    this.contactPositionIndex = 3;

    this.informationText1 = 'IfYouHaveBeenHereBefore';
    this.informationText2 = 'GoToLogin';
    this.informationText3 = 'AndClickForgotPassword';
    this.informationAction = this.goBackToLogin;
    this.informationActionTextIndex = 2;
  }

  public setCreationOfNewPatientNotAllowed() {
    this.success = false;
    this.messageActionDone = 'AccountCreationFailed';
    this.messageActionDetailsText1 = 'PleaseContactUs';
    this.messageActionDetailsText2 = 'ToCreateRecordForNewPatient';
    this.contactPositionIndex = 2;

    this.informationText1 = 'IfYouHaveBeenHereBefore';
    this.informationText2 = 'GoBackLowerCase';
    this.informationText3 = 'ToSearchAgain';
    this.informationAction = this.goBackToSearch;
    this.informationActionTextIndex = 2;
  }

  public setMultiplePatientsFoundOnAccountCreation() {
    this.success = false;
    this.messageActionDone = 'AccountCreationFailed';
    this.messageActionDetailsText1 = 'MultiplePatientsFound';
    this.messageActionDetailsText2 = 'PleaseContactUs';
    this.contactPositionIndex = 3;

    this.informationText1 = 'IfYouLikeToCheckAgain';
    this.informationText2 = 'GoBackLowerCaseWithDot';
    this.informationAction = this.goBackToSearch;
    this.informationActionTextIndex = 2;
  }

  public setMultiplePatientsFoundOnForgotPassword() {
    this.success = false;
    this.messageActionDone = 'PatientPasswordChangeFailed';
    this.messageActionDetailsText1 = 'MultiplePatientsFound';
    this.messageActionDetailsText2 = 'PleaseContactUs';
    this.contactPositionIndex = 3;

    this.informationText1 = 'IfYouLikeToCheckAgain';
    this.informationText2 = 'GoBackLowerCaseWithDot';
    this.informationAction = this.goBackToSearch;
    this.informationActionTextIndex = 2;
  }

  public setPatientNotFoundOnForgotPassword() {
    this.success = false;
    this.messageActionDone = 'PatientPasswordChangeFailed';
    this.messageActionDetailsText1 = 'PatientRecordNotFound';
    this.messageActionDetailsText2 = 'PleaseContactUs';
    this.contactPositionIndex = 3;

    this.informationText1 = 'IfYouLikeToCheckAgain';
    this.informationText2 = 'GoBackLowerCaseWithDot';
    this.informationAction = this.goBackToSearch;
    this.informationActionTextIndex = 2;
  }

  public setPatientPortalAccountNotFoundOnForgotPassword() {
    this.success = false;
    this.messageActionDone = 'PatientPasswordChangeFailed';
    this.messageActionDetailsText1 = 'PatientPortalAccountNotFound';
    this.messageActionDetailsText2 = 'PleaseContactUs';
    this.contactPositionIndex = 3;

    this.informationText1 = 'IfYouLikeToCheckAgain';
    this.informationText2 = 'GoBackLowerCaseWithDot';
    this.informationAction = this.goBackToSearch;
    this.informationActionTextIndex = 2;
  }

  public setErrorDuringAccountCreationOrForgotPassword() {
    this.success = false;
    this.messageActionDone = 'ErrorDuringAccountCreateOrForgotPassword';
    this.messageActionDetailsText1 = 'PleaseContactUs';
    this.contactPositionIndex = 2;
  }

  public setErrorDuringPatientSearch() {
    this.success = false;
    this.messageActionDone = 'ErrorDuringPatientSearch';
    this.messageActionDetailsText1 = 'PleaseContactUs';
    this.contactPositionIndex = 2;
  }

  public setOneTimeCodeGenerationFailedOnAccountCreation(isContactInfoMissing: boolean, isErrorDuringGeneration: boolean) {
    this.success = false;
    if (isContactInfoMissing) {
      this.messageActionDone = 'AccountCreationFailed';
      this.messageActionDetailsText1 = 'PleaseContactUs';
      this.messageActionDetailsText2 = 'AndProvideTheFollowingInfo';
      this.contactPositionIndex = 2;

      this.informationText1 = 'ContactInfoMissingForPatient';
    } else if (isErrorDuringGeneration) {
      this.messageActionDone = 'ErrorDuringOneTimeCodeGeneration';
      this.messageActionDetailsText1 = 'PleaseContactUs';
      this.contactPositionIndex = 2;
    }
  }

  public setOneTimeCodeGenerationFailedOnForgotPassword(isContactInfoMissing: boolean, isErrorDuringGeneration: boolean) {
    this.success = false;
    if (isContactInfoMissing) {
      this.messageActionDone = 'PatientPasswordChangeFailed';
      this.messageActionDetailsText1 = 'PleaseContactUs';
      this.messageActionDetailsText2 = 'AndProvideTheFollowingInfo';
      this.contactPositionIndex = 2;

      this.informationText1 = 'ContactInfoMissingForPatient';
    } else if (isErrorDuringGeneration) {
      this.messageActionDone = 'ErrorDuringOneTimeCodeGeneration';
      this.messageActionDetailsText1 = 'PleaseContactUs';
      this.contactPositionIndex = 2;
    }
  }

  public setPatientCreationFailed() {
    this.success = false;
    this.messageActionDone = 'AccountCreationFailed';
    this.messageActionDetailsText1 = 'PleaseContactUs';
    this.contactPositionIndex = 2;
  }

  public setOneTimeCodeExpiredOnAccountCreation() {
    this.success = false;
    this.messageActionDone = 'AccountCreationFailed';
    this.messageActionDetailsText1 = 'OneTimeCodeExpired';
    this.contactInfo = null;

    this.informationText1 = 'Please';
    this.informationText2 = 'GoBackLowerCase';
    this.informationAction = this.goBackToOneTimeCode;
    this.informationText3 = 'ToFillNewOneTimeCode';
    this.informationActionTextIndex = 2;
  }

  public setOneTimeCodeExpiredOnForgotPassword() {
    this.success = false;
    this.messageActionDone = 'PatientPasswordChangeFailed';
    this.messageActionDetailsText1 = 'OneTimeCodeExpired';
    this.contactInfo = null;

    this.informationText1 = 'Please';
    this.informationText2 = 'GoBackLowerCase';
    this.informationAction = this.goBackToOneTimeCode;
    this.informationText3 = 'ToFillNewOneTimeCode';
    this.informationActionTextIndex = 2;
  }

  public setErrorDuringOneTimeCodeValidation() {
    this.success = false;
    this.messageActionDone = 'ErrorDuringOneTimeCodeValidation';
    this.messageActionDetailsText1 = 'PleaseContactUs';
    this.contactPositionIndex = 2;
  }

  public setPasswordInvalidOnAccountCreation() {
    this.success = false;
    this.messageActionDone = 'AccountCreationFailed';
    this.messageActionDetailsText1 = 'PasswordInvalid';
    this.contactInfo = null;

    this.informationText1 = 'PleaseRefreshThePageInBrowser';
  }

  public setPasswordInvalidOnForgotPassword() {
    this.success = false;
    this.messageActionDone = 'PatientPasswordChangeFailed';
    this.messageActionDetailsText1 = 'PasswordInvalid';
    this.contactInfo = null;

    this.informationText1 = 'PleaseRefreshThePageInBrowser';
  }

  public setAccountCreationSummary(result: CreateAccountResult) {
    switch (result) {
      case CreateAccountResult.AccountCreatedSuccessfully: {
        this.success = true;
        this.messageActionDone = 'AccountCreatedSuccessfully';
        break;
      }
      case CreateAccountResult.CreationOfNewPatientNotAllowed: {
        this.setCreationOfNewPatientNotAllowed();
        break;
      }
      case CreateAccountResult.FailedToCreatePatient: {
        this.setPatientCreationFailed();
        break;
      }
      case CreateAccountResult.MultiplePatientsFound: {
        this.setMultiplePatientsFoundOnAccountCreation();
        break;
      }
      case CreateAccountResult.PatientAccountAlreadyExists: {
        this.setAccountAlreadyExists();
        break;
      }
      case CreateAccountResult.OneTimeCodeIsExpired: {
        this.setOneTimeCodeExpiredOnAccountCreation();
        break;
      }
      case CreateAccountResult.PasswordIsInvalid: {
        this.setPasswordInvalidOnAccountCreation();
        break;
      }
      default: {
        break;
      }
    }
  }

  public setPasswordChangedSummary(result: ChangePasswordResult) {
    switch (result) {
      case ChangePasswordResult.PasswordChangedSuccessfully: {
        this.success = true;
        this.messageActionDone = 'PasswordChangedSuccessfully';
        break;
      }
      case ChangePasswordResult.OneTimeCodeIsExpired: {
        this.setOneTimeCodeExpiredOnForgotPassword();
        break;
      }
      case ChangePasswordResult.PasswordIsInvalid: {
        this.setPasswordInvalidOnForgotPassword();
        break;
      }
      default: {
        break;
      }
    }
  }

  public goBackToLogin() {
    this.backToLogin.emit();
  }

  public goBackToSearch() {
    this.backToSearch.emit(this.patient);
  }

  public goBackToOneTimeCode() {
    this.backToOneTimeCode.emit(this.patient);
  }

  public reset() {
    this.messageActionDone = '';
    this.messageActionDetailsText1 = '';
    this.messageActionDetailsText2 = '';
    this.messageActionDetailsText3 = '';
    this.contactPositionIndex = 2;
    this.contactInfo = this.sysConfig.MainContactTelephone;

    this.informationText1 = '';
    this.informationText2 = '';
    this.informationText3 = '';
    this.informationActionTextIndex = 0;
    this.informationAction = null;
  }
}
